/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-12-05",
    versionChannel: "nightly",
    buildDate: "2023-12-05T00:14:44.474Z",
    commitHash: "aa6dc221245015cb7bd8d0f2404f6b63dc6b5cc9",
};
